/*=========================================================================================
  File Name: module-customsdeclaration.js
  Description: Custom Declaration Module
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: DQDUY
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-customsdeclaration-state';
import mutations from './module-customsdeclaration-mutations';
import actions from './module-customsdeclaration-actions';
import getters from './module-customsdeclaration-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
